import { render, staticRenderFns } from "./selectSource.vue?vue&type=template&id=2bddc365&scoped=true"
import script from "./selectSource.vue?vue&type=script&lang=js"
export * from "./selectSource.vue?vue&type=script&lang=js"
import style0 from "./selectSource.vue?vue&type=style&index=0&id=2bddc365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bddc365",
  null
  
)

export default component.exports